import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { RefObject } from "react";

import { WorkspaceDataplane } from "src/clients/flow-api";
import { ServiceInfraMetadata } from "src/clients/router";
import { useOnScreen } from "src/hooks/useOnScreen";
import { getInfoEndpoint } from "src/powertools/utils";

const wsInfoKey = (id: string) => ["wsinfo", id] as const;

export const useWsInfoLazy = (
  workspace: WorkspaceDataplane,
  ref: RefObject<HTMLElement>,
) => {
  const isVisible = useOnScreen(ref);

  return useQuery<ServiceInfraMetadata, Error>({
    queryKey: wsInfoKey(workspace.id),
    queryFn: async () =>
      (await axios.get(getInfoEndpoint(workspace)))
        .data as ServiceInfraMetadata,
    enabled: isVisible, // Only query when the workspace is visible
    staleTime: 5 * 60 * 1000, // 5 minutes cache
    retry: 1, // Only retry once to avoid hammering failed workspaces
  });
};
